module.exports = __webpack_public_path__ + "assets/img/one.716aace4.jpg";